import { useMemo, useState } from 'react';
import { useLang } from 'hooks/lang';

import { ResponsiveOverlay, Tabs } from 'components/Blocks';

import { ProjectTitle } from './Title';
import { Details } from './Details';
import { ProjectCosts } from './Costs';
import { ExtraInformation } from './ExtraInformation';
import { ProjectDemographics } from './Demographics';

import { useProjectProfile } from 'pages/Projects/ProjectProfile/context';
import { ProjectOptionOverlayProps } from '../createProjectOption';

const tabComponents: Record<string, typeof Details> = {
  data: Details,
  costs: ProjectCosts,
  extra: ExtraInformation,
  demographics: ProjectDemographics,
};

export function ProjectInfoModal({ isOpen, close }: ProjectOptionOverlayProps) {
  const { t } = useLang();

  const { project } = useProjectProfile();

  const [tab, setTab] = useState('data');

  const Component = useMemo(() => tabComponents[tab], [tab]);

  if (!project) return null;

  return (
    <ResponsiveOverlay
      close={close}
      isOpen={isOpen}
      width="min(90vw, 760px)"
      className="min-h-[600px] max-w-full overflow-y-auto"
      allowEscape
      preventOpenAutoFocus
    >
      <ProjectTitle project={project} />

      <Tabs
        type="highlighted"
        value={tab}
        onTabChange={setTab}
        blockKeyboardNav
        tabs={[
          {
            value: 'data',
            label: t('data'),
          },
          {
            value: 'costs',
            label: t('costs'),
          },
          {
            value: 'extra',
            label: t('extra'),
          },
          {
            value: 'demographics',
            label: t('demographics'),
          },
        ]}
      />

      <Component />
    </ResponsiveOverlay>
  );
}
